import { createCommand } from 'lexical'

export const INSERT_HASHTAG_MENTION = createCommand('INSERT_HASHTAG_MENTION')
